import type { IBannerRowContainerTemplateProps } from "@setplex/arcana"

import type { JSX } from 'react'

import { BannerRowContainerTemplate } from "/app/libraries/arcana/src/containers/RowContainer/Templates/index.ts"

import { useUnit } from 'effector-react'
import * as entitiesPlayerTrailerModel from '~/entities/player/trailer/model'
import { TrailerPlayerPortal } from '~/widgets/Player/TrailerPlayerPortal'

/**
 * Wraps BannerRowContainerTemplate with TrailerPlayerPortal for skin-based banners.
 * Renders the trailer player into the slot of the currently visible banner.
 */
export const BannerRowContainerWithTrailerPortal = (
  props: IBannerRowContainerTemplateProps
): JSX.Element => {
  const playerSlotEl = useUnit(
    entitiesPlayerTrailerModel.$playerSlotEl
  ) as HTMLDivElement | null

  return (
    <>
      <BannerRowContainerTemplate {...props} />
      <TrailerPlayerPortal el={playerSlotEl ?? undefined} />
    </>
  )
}
